import { MentionsLegalesComponent } from './mentions-legales/mentions-legales';
import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { GuardsService } from './shared/services/guards.service';
import { HomeComponent } from './home/home.component';
import { Factures } from './factures/factures';
import { ListeAppelASupport } from './appel-a-support/liste-appel-a-support/liste-appel-a-support';
import { Commandes } from './commandes/commandes';
import { PA } from './pa/pa';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'set-password', component: ResetPasswordComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'app-not-found', component: NotFoundComponent },
    { path: 'mentions-legales', component: MentionsLegalesComponent, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: 'factures', component: Factures, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: 'home', component: HomeComponent, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: 'appelASupport', component: ListeAppelASupport, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: 'appelASupport/:idAs', component: ListeAppelASupport, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: 'commandes', component: Commandes, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: 'factureElectronique', component: PA, runGuardsAndResolvers: 'always', canActivate: [GuardsService] },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '**', redirectTo: 'app-not-found' },
];